type Coord = [number, number];
type NestedCoords = Coord | NestedCoords[];

function collectCoords(coords: NestedCoords, out: Coord[]) {
  if (typeof coords[0] === "number") {
    out.push(coords as Coord);
    return;
  }
  for (const c of coords as NestedCoords[]) collectCoords(c, out);
}

/** Bounding box [w,s,e,n] across every feature's geometry, regardless of geometry type. */
export function computeFeatureCollectionBbox(
  fc: { features: { geometry: { coordinates: unknown } }[] } | null | undefined,
): [number, number, number, number] | null {
  if (!fc || fc.features.length === 0) return null;
  const coords: Coord[] = [];
  for (const f of fc.features) {
    collectCoords(f.geometry.coordinates as NestedCoords, coords);
  }
  let w = Infinity, s = Infinity, e = -Infinity, n = -Infinity;
  for (const [lng, lat] of coords) {
    if (lng < w) w = lng;
    if (lng > e) e = lng;
    if (lat < s) s = lat;
    if (lat > n) n = lat;
  }
  if (!isFinite(w)) return null;
  return [w, s, e, n];
}
